module.exports = __webpack_public_path__ + "img/Whiplash_Splash.3d4440ca.jpg";